import { defineTokens } from "@pandacss/dev";

/**
 * Border width tokens
 * Define reusable border thickness values for consistent outlines and separators.
 */
export const borderWidths = defineTokens.borderWidths({
	thin: { value: "1px" },
	thick: { value: "2px" },
});
